export default {
  add: "Hinzufügen",
  apply: "Anwenden",
  assign: "Zuordnen",
  attributeSets: "Attribut Sets",
  attributes: "Attribute",
  back: "Zurück",
  close: "Schließen",
  cancel: "Abbrechen",
  change: "Ändern",
  changePassword: "Passwort ändern",
  confirm: "Bestätigen",
  continue: "Fortsetzen",
  changeVersion: "Version ändern",
  showDetails: "Details anzeigen",
  hideDetails: "Details verbergen",
  create: "Erstellen",
  click: "Klicken Sie",
  here: "hier",
  toChangeThat: "um das zu ändern",
  createNewAttribute: "Neues Attribut anlegen",
  createdBy: "erstellt von",
  delete: "Löschen",
  deleteSet: "Set löschen",
  done: "Fertig",
  edit: "Bearbeiten",
  editName: "Name bearbeiten",
  editSet: "Set bearbeiten",
  editVersion: "VERSION BEARBEITEN",
  logout: "Abmelden",
  new: "Neu / Neue / Neuen ",
  newLog: " Neuer Log",
  next: "Weiter",
  no: "Nein",
  OK: "OK",
  deleteAnyway: "TROTZDEM LÖSCHEN",
  remove: "Entfernen",
  replace: "Ersetzen",
  reserve: "Reservieren",
  run: "Ausführen",
  save: "Speichern",
  saveChanges: "Änderungen speichern",
  send: "Senden",
  settings: "Einstellungen",
  sort: "Sortieren",
  submit: "Absenden",
  unassign: "Abwählen",
  unselect: "Abwählen",
  undoChanges: "Änderungen rückgängig machen",
  yes: "Ja",
  deploy: "Bereitstellen",
  choose: "Wählen",
  select: "Auswählen",
};
